<template>
    <div class="export-faq-modal-wrapper">
        <TitleBaseBox :title="titleLable" :noButton="true" @close="close">
            <div class="export-content">
                <p class="tip">{{ tipsLabel }}</p>
                <div class="export-select">
                    <span>{{ segmentLabbel }}</span>
                    <el-select v-model="value" class="select-options">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
                <div class="popbtn import-btn-box">
                    <RoundButton class="cancel-btn" @btnClick="cancelClick" :text="$t('zhiji.common.cancel')"></RoundButton>
                    <RoundButton class="export-btn" @btnClick="exportClick" :text="$t('zhiji.common.export')"></RoundButton>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import { URLs } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "ExportFaqModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        RoundButton
    },
    data() {
        return {
            options: [],
            value: 1
        };
    },
    computed: {
        tipsLabel() {
            return this.$t("zhiji.knowlege.exportModal.exportTips");
        },
        segmentLabbel() {
            return this.$t("zhiji.knowlege.exportModal.exportSegment");
        },
        titleLable() {
            return this.data.type === "set_id" ? this.$t("zhiji.knowlege.exportModal.allExport") : this.$t("zhiji.knowlege.exportModal.partExport");
        }
    },
    mounted() {
        this.zhiji
            .requestByServiceName("queryExportTotal", {
                type: this.data.type,
                setId: this.data.sceneId || "",
                questionIds: this.data.rowIds
            })
            .then(total => {
                this.optionsHandle(total);
            });
    },
    methods: {
        optionsHandle(total) {
            if (total > 0) {
                const num = Math.ceil(total / 500);
                let options = [];
                for (let i = 1; i <= num; i++) {
                    options.push({
                        value: i,
                        label: this.$t("zhiji.knowlege.exportModal.link") + i
                    });
                }
                this.options = options;
            } else {
                this.options = [
                    {
                        value: 1,
                        label: this.$t("zhiji.knowlege.exportModal.link") + 1
                    }
                ];
            }
        },
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        exportClick() {
            let reqUrl =
                URLs.EXPORT_FAQ_FILE +
                `?export_type=${this.data.type}&set_id=${this.data.sceneId || ""}&question_ids=${this.data.rowIds || ""}&page=${this.value}&size=500`;

            reqUrl = reqUrl.replace(/\s+/g, "");

            this.zhiji.requestByServiceName("getDownloadToken", reqUrl).then(result => {
                window.open(result, "_blank");
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.export-faq-modal-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .tip {
        color: #ff782b;
        margin-bottom: 20px;
        max-width: 400px;
    }

    .export-content {
        padding: 0px 23px 0 0px;

        .export-select {
            display: flex;
            align-items: center;
            margin-bottom: 80px;
        }
    }

    .import-btn-box {
        text-align: right;
        .primary-btn {
            &:last-child {
                margin-right: 0;
            }
        }
    }
}
.select-options {
    margin-left: 16px;
    flex: 1;
}

.export-btn {
    box-shadow: none !important;
}
.cancel-btn {
    background-color: #fff !important;
    color: #41475e;
}
</style>
